import styled, { css } from 'styled-components';

export const TagList = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	flex-wrap: wrap;
`;

interface TagProps {
	highlight?: boolean;
}

const getBackgroundColor = ({ highlight, theme }: TagProps & { theme: any }) =>
	highlight ? theme.colors.primary.extraLight : '';

const TagCss = css<TagProps>`
	border-radius: 4px;
	padding: 4px 10px;
	font-weight: 600;
	font-size: 1.3rem;
	line-height: 1.6rem;
	background-color: ${getBackgroundColor};
	color: ${({ theme }) => theme.colors.background.dark};
	white-space: nowrap;
`;

export const Tag = styled.span<TagProps>`
	${TagCss}
`;

export const TagLink = styled.a<TagProps>`
	${TagCss}
	text-decoration: none;
	&:hover {
		background-color: ${({ theme }) =>
			getBackgroundColor({ highlight: true, theme })};
	}
`;
